var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.participantId)?_c('div',{staticClass:"m-2 center-ssn-btn"},[_c('button',{staticClass:"btn btn-default btn-sm",on:{"click":_vm.copyParticipantSsn}},[_vm._v("Copy SSN")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c5e7cd5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/action-items/types/CopyParticipantSsn.vue
// module id = null
// module chunks = 